var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "vfo1zzjkya",
    d: "M9.019 6h-1.5c-.276 0-.5-.223-.5-.5s.224-.5.5-.5h1.5c1.103 0 2-.897 2-2s-.897-2-2-2h-5.5c-1.103 0-2 .897-2 2s.897 2 2 2c.276 0 .5.223.5.5s-.224.5-.5.5c-1.655 0-3-1.346-3-3 0-1.655 1.345-3 3-3h5.5c1.654 0 3 1.345 3 3 0 1.654-1.346 3-3 3zm4.5 2.5h-5.5c-1.655 0-3-1.346-3-3 0-1.655 1.345-3 3-3h1.5c.276 0 .5.224.5.5s-.224.5-.5.5h-1.5c-1.103 0-2 .897-2 2s.897 2 2 2h5.5c1.103 0 2-.897 2-2s-.897-2-2-2c-.277 0-.5-.224-.5-.5s.223-.5.5-.5c1.654 0 3 1.345 3 3 0 1.654-1.346 3-3 3z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1089 -230) translate(1076 167) translate(12 63) translate(.481 4)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "wlvjhjvnab",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vfo1zzjkya"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D6DCE8",
    xlinkHref: "#vfo1zzjkya"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#8A8E96",
    mask: "url(#wlvjhjvnab)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H18V18H0z",
    transform: "translate(-1 -5)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkGrey);
export default __webpack_public_path__ + "static/media/link-grey.422b21a67d3976d15d01788a74e10984.svg";
export { ForwardRef as ReactComponent };